const SupplierExportStatus = {
  None: 0,
  Complete: 10,
  Pending: 20,
  Failed: 30,
};

export default SupplierExportStatus;
